import Page2026 from './Page2026';
export default Page2026;
